import { Flex, Heading } from "@chakra-ui/react";
import React, { Component, ErrorInfo, ReactNode } from "react";
import { logEvent } from "../firebase";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logEvent({ event: "exception", params: { error, errorInfo } });
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Flex width="100vw" height="100vh" justify="center" align="center">
          <Heading>Sorry.. there was an error</Heading>
        </Flex>
      );
    }

    return this.props.children;
  }
}
